import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchPublicSettings } from "@/lib/api";
import { LOGO_BLACK, TAGLINE } from "@/lib/branding";

export const Header = ({ minimal = false }) => {
  const [logoUrl, setLogoUrl] = useState(LOGO_BLACK);

  useEffect(() => {
    fetchPublicSettings()
      .then((s) => setLogoUrl(s.logo_url || LOGO_BLACK))
      .catch(() => setLogoUrl(LOGO_BLACK));
  }, []);

  return (
    <header className="w-full border-b border-[rgba(35,82,119,0.10)] bg-white/70 backdrop-blur-sm sticky top-0 z-40">
      <div className="max-w-[1040px] mx-auto px-4 sm:px-6 py-2.5 flex items-center justify-between">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3 no-underline">
          <span className="flex flex-col items-start gap-0.5">
            <img src={logoUrl} alt="Gino Body & Soul" className="h-8 w-auto" data-testid="header-logo-image" />
            <span className="text-[9px] leading-none font-medium tracking-wide text-[#333333]" data-testid="header-tagline">
              {TAGLINE}
            </span>
          </span>
          <span className="hidden sm:inline-block text-[11px] font-medium px-2 py-0.5 rounded-full bg-[#235277] text-[#EAFE63] tracking-wide">
            CYCLIQ
          </span>
        </Link>
        {!minimal && (
          <span className="text-xs text-[#9E9E9E] font-medium hidden sm:block">
            Gino Body &amp; Soul
          </span>
        )}
      </div>
    </header>
  );
};
